var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InputNumber',{directives:[{name:"show",rawName:"v-show",value:(this.value !== null),expression:"this.value !== null"}],attrs:{"label":_vm.label || _vm.propertyName,"value":_vm.value,"step":_vm.step,"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }